import {Component, OnInit} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {
  FrontendNavigationComponent
} from '../../../../frontend/player-frontend/frontend-navigation/frontend-navigation.component';
import {MenuItem} from 'primeng/api';
import {PLAYER_PREFIX_FULL} from '../../../player.routes';

@Component({
  selector: 'app-player-profile-dashboard',
  standalone: true,
  imports: [
    FrontendNavigationComponent,
    RouterOutlet
  ],
  templateUrl: './player-profile-dashboard.component.html',
  styleUrl: './player-profile-dashboard.component.scss'
})
export class PlayerProfileDashboardComponent implements OnInit
{
  navigationItems: MenuItem[];

  ngOnInit(): void
  {
    this.initNavigationItems();
  }

  private initNavigationItems(): void
  {
    this.navigationItems = [
      {
        label: 'DASHBOARD',
        routerLink: PLAYER_PREFIX_FULL + '/profile/dashboard/home',
        url: 'home',
        // icon: 'pi pi-list',
        // iconClass: isPro ? '' : 'PRO'
      },
      {
        label: 'MY_LEAGUES',
        routerLink: PLAYER_PREFIX_FULL + '/profile/dashboard/my-leagues',
        url: 'my-leagues',
        // icon: 'pi pi-list',
        // iconClass: isPro ? '' : 'PRO'
      }
    ];
    console.log('navigationItems:', this.navigationItems);
  }
}
